import { createArticle } from '../ArticleParse'
import { Priority } from '../../common/types'
import type { Article, Layoutable, ParsedArticleContent } from '../types'

export const emptyAreaForSizedArticle = { x: '', y: 0, width: '', height: '', fromLeft: false }

export const updateArticleObject = (
  article: Partial<Article>,
  layoutable: Layoutable,
  parsedObject: ParsedArticleContent,
  largestOrder: number,
  otherPriorityIndex?: number
): Article => {
  const newArticle = createArticle(article, layoutable, parsedObject, true, otherPriorityIndex) as Article
  newArticle.order = article.priority === Priority.Other ? (article.order ?? largestOrder + 1) : 0
  return newArticle
}
